<template>
  <div>
    <file-up-load
      :applyType="$route.params.applyType"
      :editInfo="params"
    ></file-up-load>
  </div>
</template>

<script>
import fileUpLoad from "@/components/szStudioFileupload/index";
export default {
  name: "",
  components: {
    fileUpLoad,
  },
  props: {},
  data() {
    return {
      params: this.$route.params.applyFiles ? this.$route.params : null,
    };
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss"></style>
